import { SectionTypeEnum } from '@nucleus/types/web';
import { SectionPayloadDefaultsBuilder } from './defaults/SectionPayloadDefaultsBuilder';
import CalendarDefaults from './defaults/sections/CalendarDefaults';
import CardDefaults from './defaults/sections/CardDefaults';
import EmbedDefaults from './defaults/sections/EmbedDefaults';
import FooterDefaults from './defaults/sections/FooterDefaults';
import GalleryDefaults from './defaults/sections/GalleryDefaults';
import HeaderDefaults from './defaults/sections/HeaderDefaults';
import InfoDefaults from './defaults/sections/InfoDefaults';
import LeaderDefaults from './defaults/sections/LeaderDefaults';
import ListDefaults from './defaults/sections/ListDefaults';
import PostDefaults from './defaults/sections/PostDefaults';
import SermonDefaults from './defaults/sections/SermonDefaults';
import {
  PostContentDefaults,
  PostHeaderDefaults,
  PostSearchRequestDefaults,
  PostSearchResultsDefaults,
  SermonActionsDefaults,
  SermonMediaDefaults,
  SermonSearchRequestDefaults,
  SermonSearchResultsDefaults,
} from './defaults/sections/generated';

const builder = new SectionPayloadDefaultsBuilder();

builder
  .addSection(SectionTypeEnum.Info, InfoDefaults)
  .addSection(SectionTypeEnum.List, ListDefaults)
  .addSection(SectionTypeEnum.Gallery, GalleryDefaults)
  .addSection(SectionTypeEnum.Card, CardDefaults)
  .addSection(SectionTypeEnum.Leader, LeaderDefaults)
  .addSection(SectionTypeEnum.Embed, EmbedDefaults)
  .addSection(SectionTypeEnum.Calendar, CalendarDefaults)
  .addSection(SectionTypeEnum.Header, HeaderDefaults)
  .addSection(SectionTypeEnum.Footer, FooterDefaults)
  .addSection(SectionTypeEnum.Sermon, SermonDefaults)
  .addSection(SectionTypeEnum.SermonActions, SermonActionsDefaults)
  .addSection(SectionTypeEnum.SermonMedia, SermonMediaDefaults)
  .addSection(SectionTypeEnum.SermonSearchRequest, SermonSearchRequestDefaults)
  .addSection(SectionTypeEnum.SermonSearchResults, SermonSearchResultsDefaults)
  .addSection(SectionTypeEnum.PostContent, PostContentDefaults)
  .addSection(SectionTypeEnum.PostHeader, PostHeaderDefaults)
  .addSection(SectionTypeEnum.PostSearchRequest, PostSearchRequestDefaults)
  .addSection(SectionTypeEnum.PostSearchResults, PostSearchResultsDefaults)
  .addSection(SectionTypeEnum.Post, PostDefaults);

export { CardItemDefaults } from './defaults/CardItem';
export { ListItemDefaults } from './defaults/ListItem';

export const SectionPayloadDefaults = builder.build();
